import {
  useReactMutation,
  useTranslation,
  getPostServicePromise
} from '@invision/core';
import type {
  SecurityCreateSessionRequest,
  SecurityCreateSessionResponse
} from 'invApi';

export function useCreateSessionMutation() {
  const { t } = useTranslation();

  return useReactMutation<
    SecurityCreateSessionResponse,
    SecurityCreateSessionRequest
  >(
    ['createSession'],
    (request: SecurityCreateSessionRequest) =>
      getPostServicePromise(
        { path: 'Security/CreateSession' },
        {
          payload: request,
          faults: {
            '107': t('Account is locked. Please contact support.'),
            '110': t('Role not found'),
            '111': t('User not found'),
            '123': t('Invalid username or password')
          }
        }
      ),
    {},
    {
      useLoadingIndicator: true,
      errorHandling: 'unhandled' // Let the component surface errors via useNotification (global toast is not configured pre-authentication)
    }
  );
}
